import { h, Component } from 'preact'
import { connect } from 'react-redux'
import reduce from '../reducers'
import store from '../store'
import * as actions from '../actions'
import constants from '../constants'

import util, { getSvgPath } from '../util'
import Renderer from '../canvas/renderer'
import MenuObject from '../canvas/menu-object'
import CustomColorPicker from './CustomColorPicker'
import tinycolor from 'tinycolor2'
import { DownOutlined, LeftOutlined } from "@ant-design/icons";
import wordArt from '../canvas/word-art'

export default @connect(reduce, actions)
class AsideColorPicker extends Component {
  constructor() {
    super()

    this.state = {
      ogColorData: ''
    }

    this.goToStyles = (scroll=false) => {
      store.dispatch(actions.goToView("text-mo-style"));
      if (scroll) {
        util.nextTick(() => {
          let scroller = $('.aside-mo-styles.scroller');
          scroller.scrollTop('1000');
        })
      }
    }

    this.goToEdit = () => {
      let activeIdx = this.props.colorPickerType[1].activeIdx;
      store.dispatch(actions.goToView("text-mo-style"));
      // util.nextTick(() => {
      //     let toClick = $('#app-aside .items-list>div').children().eq(activeIdx).find('.li-item-edit>.item');
      //     toClick[0].click();
      //     util.nextTick(() => {
      //         $('#app-aside .items-list').scrollTop(activeIdx * 75);
      //     });
      // });
    }

    this.goToGraphics = () => {
      store.dispatch(actions.goToView("graphics"));
    }

    this.goToPrevView = () => {
      store.dispatch(actions.goToView(store.getState().prevAsideView));
    }

    this.closeMobile = () => {
      store.dispatch(actions.setIsMobileAside(false));
    }

    this.updateSelectedIconList = (iconList, value) => {
      const newIconList = [];
      iconList.forEach(icon => {
        icon.fill = value;
        newIconList.push(icon)
      });
      return newIconList;
    }

    this.handleChange = (colorData) => {
      let $elements = this.props.$elements;

      let $element = this.props.$element;
      let pickerType = Array.isArray(this.props.colorPickerType) ? this.props.colorPickerType[0] : this.props.colorPickerType;
      let pickerConfig = Array.isArray(this.props.colorPickerType) ? this.props.colorPickerType[1] : false;

      if (pickerType === constants.pickerTypes.backgroundFill && (!$element || !util.isPage($element))) {
        $element = util.getPageInViewport($('.page'));
      }

      let props = this.props;

      switch (pickerType) {
        case constants.pickerTypes.shapeLine:
          $elements.forEach(function (el) {
            if (colorData.mode === 'no-fill') {
              Renderer.updateElementLineColor(el, 'none');
            } else {
              Renderer.updateElementLineColor(el, colorData.colors[0]);
            }
            props.updateElementAttribute('strokeColor', colorData.colors[0]);
          })
          break;

        case constants.pickerTypes.shapeFill:
          $elements.forEach(function (el) {
            let val = el.attr('data-opacity') !== '1' ? parseFloat(el.attr('data-opacity')) : 1;
            if (colorData.mode === 'no-fill') {
              val = 1;
              props.updateElementAttribute('opacity', val * 100);
            }
            let newColorPrimary = tinycolor(colorData.colors[0]).setAlpha(val);
            let newColorSecondary = tinycolor(colorData.colors[1]).setAlpha(val);
            colorData.colors = [newColorPrimary.toRgbString(), newColorSecondary.toRgbString()];

            Renderer.updateElementFillColor(el, colorData, val);
            props.updateElementAttribute('fillColor', colorData.colors[0]);
          })
          break;

        case constants.pickerTypes.backgroundFill:
          Renderer.updatePageBackground($element, colorData);
          props.updateElementAttribute('backgroundColor', colorData.colors[0]);
          break;

        case constants.pickerTypes.textFont:
          $elements.forEach(function (el) {
            Renderer.updateTextColor(el, colorData);
            props.updateElementAttribute('color', colorData.colors[0]);
          })
          break;

        case constants.pickerTypes.textFill:
          $elements.forEach(function (el) {
            let val = el.attr('data-bg-opacity') !== '1' ? parseFloat(el.attr('data-bg-opacity')) : 1;
            if (colorData.mode === 'no-fill') {
              val = 1;
              props.updateElementAttribute('bgOpacity', val);
            }
            let newColorPrimary = tinycolor(colorData.colors[0]).setAlpha(val);
            let newColorSecondary = tinycolor(colorData.colors[1]).setAlpha(val);
            colorData.colors = [newColorPrimary.toRgbString(), newColorSecondary.toRgbString()];

            Renderer.updateTextFill(el, colorData, val);
            props.updateElementAttribute('bgColor', colorData.colors[0]);
          })
          break;

        case constants.pickerTypes.textLine:
          $elements.forEach(function (el) {
            Renderer.updateTextLine(el, colorData);
            props.updateElementAttribute('borderBottomColor', colorData.colors[0]);
          })
          break;

        case constants.pickerTypes.videoFrameBorder:
        case constants.pickerTypes.imageBorder:
        case constants.pickerTypes.frameBorder:
        case constants.pickerTypes.qrBorder:
          $elements.forEach(function (el) {
            Renderer.updateElementBorderColor(el, colorData);
            props.updateElementAttribute('borderColor', colorData.colors[0]);
          })
          break;

        case constants.pickerTypes.moBorder:
          $elements.forEach(function (el) {
            const width = props.borderWidth / 10 + 'em';
            const patch = { type: 'mo-content', key: 'border', value: `${width} solid ${colorData.colors[0]}` };
            props.updateElementAttribute('borderColor', colorData.colors[0]);
            MenuObject.patchStyles(el, patch);
            MenuObject.fixPriceBorder($element);
          })
          break;

        case constants.pickerTypes.illustrationSwatch:
          $elements.forEach(function (el) {
            const general = JSON.parse(props.$element?.attr('data-configuration'));
            general.find(it => it.id === pickerConfig.id).color = colorData.colors[0];
            props.updateElementAttribute('illustrationConfig', general);
            Renderer.updateSvgStyleRule(el, general, pickerConfig, colorData.colors[0]);
          })
          break;

        case constants.pickerTypes.moFill:
          $elements.forEach(function (el) {
            let val = props.backgroundColorOpacity !== 100 ? props.backgroundColorOpacity / 100 : 1;
            if (colorData.mode === 'no-fill') {
              val = 1;
              props.updateElementAttribute('backgroundColorOpacity', val * 100)
            }
            let newColorPrimary = tinycolor(colorData.colors[0]).setAlpha(val);
            let newColorSecondary = tinycolor(colorData.colors[1]).setAlpha(val);
            colorData.colors = [newColorPrimary.toRgbString(), newColorSecondary.toRgbString()];

            el.attr('data-color', JSON.stringify(colorData));
            let css = util.getCssFromColorData(JSON.stringify(colorData));
            const patch = {
              type: 'mo-content',
              key: 'background',
              value: css
            };
            MenuObject.patchStyles(el, patch);
            props.updateElementAttribute('backgroundColor', colorData.colors[0]);
          })
          break;

        case constants.pickerTypes.moFont: {
          const menuObjects = props.$elements.filter(it => it.attr('data-component') === 'menu-object');
          MenuObject.patchStyles(props.isMultiSelect ? menuObjects : props.$element,
            { type: pickerConfig, key: 'color', value: colorData.colors[0] });

          if (pickerConfig === 'bin') {
            MenuObject.patchStyles(props.isMultiSelect ? menuObjects : props.$element,
              { type: 'bin-header', key: 'color', value: colorData.colors[0] });
          }
          break;
        }

        case constants.pickerTypes.moNameFont: {
          const menuObjects = props.$elements.filter(it => it.attr('data-component') === 'menu-object');
          MenuObject.patchStyles(props.isMultiSelect ? menuObjects : props.$element,
            { type: 'mo-name', key: 'color', value: colorData.colors[0] });
          break;
        }

        case constants.pickerTypes.moNotesFont: {
          const menuObjects = props.$elements.filter(it => it.attr('data-component') === 'menu-object');
          MenuObject.patchStyles(props.isMultiSelect ? menuObjects : props.$element,
            { type: 'mo-notes', key: 'color', value: colorData.colors[0] });
          break;
        }

        case constants.pickerTypes.moNameFill: {
          $elements.forEach(function (el) {
            let val = props.moNameBackgroundOpacity !== 100 ? props.moNameBackgroundOpacity / 100 : 1;
            if (colorData.mode === 'no-fill') {
              val = 1;
              props.updateElementAttribute('moNameBackgroundOpacity', val * 100)
            }
            let newColorPrimary = tinycolor(colorData.colors[0]).setAlpha(val);
            let newColorSecondary = tinycolor(colorData.colors[1]).setAlpha(val);
            colorData.colors = [newColorPrimary.toRgbString(), newColorSecondary.toRgbString()];

            el.attr('data-mo-name-color', JSON.stringify(colorData));
            let css = util.getCssFromColorData(JSON.stringify(colorData));
            const patch = {
              type: 'mo-name',
              key: 'background',
              value: css
            };
            MenuObject.patchStyles(el, patch);
            props.updateElementAttribute('moNameBackgroundColor', colorData.colors[0]);
          })
          break;
        }

        case constants.pickerTypes.moNameLine: {
          const styles = MenuObject.getStyles($element);
          const val = colorData.colors[0];
          if (styles['mo-name'] && styles['mo-name']['border-bottom']) {
            const split = styles['mo-name']['border-bottom'].split(' solid ');
            let lineWidth = '';
            if (split.length > 1) {
              lineWidth = split[0];
            } else {
              lineWidth = '0.1em';
              this.props.updateElementAttribute('moNameLineWidth', 1);
            }
            let newKey = `${lineWidth} solid ${val}`;
            MenuObject.patchStyles(props.$element, { type: 'mo-name', key: 'border-bottom', value: newKey });
          }
          this.props.updateElementAttribute('moNameLineColor', val);
          break;
        }

        case constants.pickerTypes.moNameBorder: {
          const styles = MenuObject.getStyles($element);
          const val = colorData.colors[0];
          if (styles['mo-name'] && styles['mo-name']['border']) {
            const split = styles['mo-name']['border'].split(' solid ');
            let lineWidth = '';
            if (split.length > 1) {
              lineWidth = split[0];
            } else {
              lineWidth = '0.1em';
              this.props.updateElementAttribute('moNameBorderWidth', 1);
            }
            let newKey = `${lineWidth} solid ${val}`;
            MenuObject.patchStyles(props.$element, { type: 'mo-name', key: 'border', value: newKey });
          }
          this.props.updateElementAttribute('moNameBorderColor', val);
          break;
        }

        case constants.pickerTypes.moNotesLine: {
          const styles = MenuObject.getStyles($element);
          const val = colorData.colors[0];
          if (styles['mo-notes'] && styles['mo-notes']['border-bottom']) {
            let lineWidth = styles['mo-notes']['border-bottom'].split(' solid ')[0];
            let newKey = `${lineWidth} solid ${val}`;
            MenuObject.patchStyles(props.$element, { type: 'mo-notes', key: 'border-bottom', value: newKey });
          }
          this.props.updateElementAttribute('moNotesLineColor', val);
          break;
        }

        case constants.pickerTypes.moIconFill: {
          if (Array.isArray(props.colorPickerType)) {
            const thisIcon = pickerConfig.active['icons'][pickerConfig.activeIconIdx];
            const newColor = colorData.colors[0];
            thisIcon.fill = newColor;
            const items = store.getState().menuObjectItems;
            items[pickerConfig.activeIdx] = pickerConfig.active;
            MenuObject.updateContent(props.$element, items, false, true);
            //MenuObject.singleMenuIconColorChange(thisIcon['iconKey'], newColor, props.$element.attr('id'));
          } else {
            const menuObjects = props.$elements.filter(it => it.attr('data-component') === 'menu-object');
            MenuObject.patchStyles(props.isMultiSelect ? menuObjects : props.$element,
              { type: 'icon-entry', key: 'color', value: colorData.colors[0] });

            const items = store.getState().menuObjectItems;
            const newItems = [];
            items.forEach(item => { item.icons = this.updateSelectedIconList(item.icons, ''); newItems.push(item); });
            store.dispatch(actions.setMenuObjectItems(newItems));
            MenuObject.updateContent(props.$element, newItems);
          }
          MenuObject.findMenuActiveIcons();
          break;
        }

        case constants.pickerTypes.highlightBorder: {
          const styles = store.getState().menuObjectStyles;
          const borderArray = styles[`item.highlighted#${pickerConfig}`]['border'].split(' ');
          let patch = { type: `item.highlighted#${pickerConfig}`, key: 'border', value: `${borderArray[0]} ${borderArray[1]} ${colorData.colors[0]}`};
          MenuObject.patchStyles(props.$element, patch);
          break;
        }

        case constants.pickerTypes.highlightFill: {
          if (colorData.mode === 'no-fill') {
            let patch = { type: `item.highlighted#${pickerConfig}`, key: 'background', value: ''};
            MenuObject.patchStyles(props.$element, patch);
          } else {
            const styles = store.getState().menuObjectStyles;
            const alpha = tinycolor(styles[`item.highlighted#${pickerConfig}`]['background']).getAlpha();
            const newBg = tinycolor(colorData.colors[0]);
            newBg.setAlpha(alpha);
            let patch = { type: `item.highlighted#${pickerConfig}`, key: 'background', value: newBg.toRgbString()};
            MenuObject.patchStyles(props.$element, patch);
          }
          break;
        }

        case constants.pickerTypes.textShadow: {
          props.$element.attr('data-shadow-color', colorData.colors[0]);
          props.updateElementAttribute('textShadowColor', colorData.colors[0]);
          wordArt.applyShadow(props.$element, props.textShadowOffset, props.textShadowDirection, props.textShadowBlur, props.textShadowOpacity/100, colorData.colors[0]);
          break;
        }
      }
      return;
    }

    this.getOgColorData = () => {
      let $element = this.props.$element;
      if (!$element) return;
      let props = this.props;

      let pickerType = Array.isArray(this.props.colorPickerType) ? this.props.colorPickerType[0] : this.props.colorPickerType;
      let pickerConfig = Array.isArray(this.props.colorPickerType) ? this.props.colorPickerType[1] : {};

      if (pickerType === constants.pickerTypes.backgroundFill && (!$element || !util.isPage($element))) {
        $element = util.getPageInViewport($('.page'));
      }

      let colorData = { mode: 'solid', colors: ['$fff', '#000'] };

      switch (pickerType) {
        case constants.pickerTypes.shapeLine: {
          const $path = getSvgPath($element);
          if ($path.attr('stroke') === 'none') {
            return { mode: 'no-fill', colors: ['#fff', '#000'] }
          } else {
            return { mode: 'solid', colors: [$path.attr('stroke'), '#000'] }
          }
        }
        case constants.pickerTypes.shapeFill: {
          const $path = getSvgPath($element);
          if ($element.attr('data-color')) {
            colorData = JSON.parse($element.attr('data-color'));
          } else if ($path.attr('fill') === 'none') {
            colorData = { mode: 'no-fill', colors: ['#fff', '#000'] };
          } else {
            colorData = { mode: 'solid', colors: [$path.attr('fill'), '#000'] };
          }
          return colorData;
        }
        case constants.pickerTypes.backgroundFill:
          if ($element.attr('data-color')) {
            colorData = JSON.parse($element.attr('data-color'));
          } else {
            colorData = { mode: 'solid', colors: [$element.css('background-color'), '#000'] };
          }
          return colorData;

        case constants.pickerTypes.textFont:
          if ($element.attr('data-color-text')) {
            colorData = JSON.parse($element.attr('data-color-text'));
          } else {
            colorData = { mode: 'solid', colors: [$element.css('color'), '#000'] };
          }
          return colorData;

        case constants.pickerTypes.textFill: {
          if ($element.attr('data-color-fill')) {
            colorData = JSON.parse($element.attr('data-color-fill'));
          } else {
            let tc = tinycolor($element.css('background-color'));
            if (tc.getAlpha() === 0) {
              colorData = { mode: 'no-fill', colors: ['#fff', '#000'] };
            } else {
              colorData = { mode: 'solid', colors: [$element.css('background-color'), '#000'] };
            }
          }
          return colorData;
        }

        case constants.pickerTypes.textLine:
          if ($element.attr('data-color-line')) {
            colorData = JSON.parse($element.attr('data-color-line'));
          } else if ($element.attr('style').indexOf('border-bottom') > -1) {
            colorData = { mode: 'solid', colors: [$element.css('border-bottom-color'), '#000'] };
          } else {
            colorData = { mode: 'solid', colors: ['#000', '#000'] };
          }
          return colorData;

        case constants.pickerTypes.videoFrameBorder:
        case constants.pickerTypes.imageBorder:
        case constants.pickerTypes.frameBorder:
        case constants.pickerTypes.qrBorder: {
          let borderObject = util.getBorderElement($element);
          if ($element.attr('data-color')) {
            colorData = JSON.parse($element.attr('data-color'));
          } else {
            colorData = { mode: 'solid', colors: [borderObject.css('border-color'), '#000'] };
          }
          return colorData;
        }

        case constants.pickerTypes.moBorder: {
          let borderColor = util.getMOBorderColor($element);
          colorData = { mode: 'solid', colors: [borderColor, '#000'] };
          return colorData;
        }

        case constants.pickerTypes.moNameBorder: {
          let borderColor = util.getMONameBorderColor($element, 'border');
          colorData = { mode: 'solid', colors: [borderColor, '#000'] };
          return colorData;
        }

        case constants.pickerTypes.moNameLine: {
          let borderColor = util.getMONameBorderColor($element, 'border-bottom');
          colorData = { mode: 'solid', colors: [borderColor, '#000'] };
          return colorData;
        }

        case constants.pickerTypes.moNotesLine: {
          let borderColor = util.getMONotesLineColor($element);
          colorData = { mode: 'solid', colors: [borderColor, '#000'] };
          return colorData;
        }

        case constants.pickerTypes.illustrationSwatch:
          colorData = { mode: 'solid', colors: [pickerConfig.color, '#000'] };
          return colorData;

        case constants.pickerTypes.moFill: {
          if ($element.attr('data-color')) {
            colorData = JSON.parse($element.attr('data-color'));
          } else {
            let styles = MenuObject.getStyles($element);
            let color = '';
            if (styles.items) {
              if (styles.items.backgroundColor) {
                color = styles.items.backgroundColor;
              } else if (styles.items.background) {
                color = styles.items.background;
              }
            }
            if (color === '') {
              colorData = { mode: 'no-fill', colors: ['#fff', '#000'] };
            } else {
              colorData = { mode: 'solid', colors: [color, '#000'] };
            }
          }
          return colorData;
        }

        case constants.pickerTypes.moFont: {
          let styles = MenuObject.getStyles($element);
          let color = '#000';
          if (styles[pickerConfig] && styles[pickerConfig]['color']) {
            color = styles[pickerConfig]['color'];
          } else if (styles['price-entry'] && styles['price-entry']['color']) {
            color = styles['price-entry']['color'];
          } else if (styles['price'] && styles['price']['color']) {
            color = styles['price']['color'];
          }
          colorData = { mode: 'solid', colors: [color, '#000'] };
          return colorData;
        }

        case constants.pickerTypes.moIconFill: {
          if (Array.isArray(props.colorPickerType)) {
            let color = pickerConfig.active['icons'][pickerConfig.activeIconIdx]['fill'];
            if (!color) {
              let styles = MenuObject.getStyles($element);
              if (styles['icon-entry'] && styles['icon-entry']['color']) {
                color = styles['icon-entry']['color'];
              } else {
                color = '';
              }
            }
            colorData = { mode: 'solid', colors: [color, '#000'] };
          } else {
            let styles = MenuObject.getStyles($element);
            if (styles['icon-entry'] && styles['icon-entry']['color']) {
              colorData = { mode: 'solid', colors: [styles['icon-entry']['color'], '#000'] };
            } else {
              colorData = { mode: 'solid', colors: ['#fff', '#000'] };
            }
          }
          return colorData;
        }

        case constants.pickerTypes.highlightBorder: {
          const styles = store.getState().menuObjectStyles;
          const borderColor = styles[`item.highlighted#${pickerConfig}`]['border'].split(' ')[1];
          colorData = { mode: 'solid', colors: [borderColor, '#000'] };
          return colorData;
        }

        case constants.pickerTypes.highlightFill: {
          const styles = store.getState().menuObjectStyles;
          const fillColor = styles[`item.highlighted#${pickerConfig}`]['background'];
          colorData = { mode: 'solid', colors: [fillColor, '#000'] };
          return colorData;
        }

        case constants.pickerTypes.textShadow: {
          colorData = { mode: 'solid', colors: [props.textShadowColor ? props.textShadowColor : '#000', '#000'] }
          return colorData;
        }

        default:
          return colorData;
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.colorPickerType !== this.props.colorPickerType || prevProps.$element !== this.props.$element) {
      this.setState({ ogColorData: this.getOgColorData() });
    }
  }

  componentWillMount() {
    this.setState({ ogColorData: this.getOgColorData() });
  }

  render(props, state) {
    let toRoot = '';
    if (Array.isArray(props.colorPickerType) && props.colorPickerType[0] === constants.pickerTypes.moFont ||
      !Array.isArray(props.colorPickerType) && props.colorPickerType === constants.pickerTypes.moNameFont ||
      !Array.isArray(props.colorPickerType) && props.colorPickerType === constants.pickerTypes.moNotesFont ||
      !Array.isArray(props.colorPickerType) && props.colorPickerType === constants.pickerTypes.moIconFill) {
      toRoot = <div class="picker-to-root">
        <div onClick={() => this.goToStyles(Array.isArray(props.colorPickerType) && props.colorPickerType[0] === constants.pickerTypes.moFont && props.colorPickerType[1].includes('modifier'))}>
          <LeftOutlined />
        </div>
        <span>Color</span>
      </div>
    } else if (!props.isMobileVersion && Array.isArray(props.colorPickerType) && props.colorPickerType[0] === constants.pickerTypes.moIconFill) {
      toRoot = <div class="picker-to-root">
        <div onClick={() => this.goToEdit()}>
          <LeftOutlined />
        </div>
        <span>Color</span>
      </div>
    } else if (props.colorPickerType === constants.pickerTypes.backgroundFill) {
      toRoot = <div class="to-root">
        <a onClick={ () => this.goToGraphics() }>
          All graphics
        </a>
        <span class="path">&gt;&nbsp; Backgrounds</span>
      </div>
    } else if (
      (!props.isMobileVersion && (props.colorPickerType === constants.pickerTypes.moBorder || props.colorPickerType === constants.pickerTypes.moFill)) ||
      (props.isMobileVersion && (props.colorPickerType === constants.pickerTypes.moNameFill || props.colorPickerType === constants.pickerTypes.moNameLine || props.colorPickerType === constants.pickerTypes.moNotesLine)) ||
      (props.isMobileVersion && Array.isArray(props.colorPickerType) && (props.colorPickerType[0] === constants.pickerTypes.highlightBorder || props.colorPickerType[0] === constants.pickerTypes.highlightFill || props.colorPickerType[0] === constants.pickerTypes.moIconFill)) ||
      (!props.isMobileVersion && props.colorPickerType === constants.pickerTypes.textShadow)
      ) {
      toRoot = <div class="picker-to-root">
        <div onClick={() => this.goToPrevView()}>
          <LeftOutlined />
        </div>
        <span>Color</span>
      </div>
    } else if (props.isMobileVersion && props.colorPickerType === constants.pickerTypes.textShadow) {
      toRoot = <div class="picker-to-root">
        <div onClick={() => this.closeMobile()}>
          <LeftOutlined />
        </div>
        <span>Color</span>
      </div>
    } else if (props.isMobileVersion) {
      toRoot = <div class="picker-to-root close-color">
        <span>Color</span>
        <div onClick={() => this.closeMobile()}>
          <DownOutlined />
        </div>
      </div>
    }

    return (<div id="app-aside-color-picker" class={(props.colorPickerType === constants.pickerTypes.backgroundFill ? 'pad-top' : toRoot !== '' ? 'mo-top' : '')}>
      {!props.isMobileVersion && toRoot}
      <CustomColorPicker
        pickerType={props.colorPickerType}
        ogColorData={state.ogColorData}
        handleChange={this.handleChange}
        designColors={props.designColors}
        brandColors={props.brand.colors || []}
        isAdmin={props.isAdmin}
        isDesigner={props.isDesigner}
        updateDesignColors={props.updateDesignColors}
        designId={props.designId}
        isMobileVersion={props.isMobileVersion} />
    </div>)
  }
}
